module.exports = __webpack_public_path__ + "assets/img/secondPrize.f6fa0f3f.png";